import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { TertiaryButton } from '@enechain/ecloud-designsystem'

import {
  type SettlementDetailLanding,
  type SettlementDetailMarket,
  toSettlementDetailLandingState,
} from '~/models/settlementDetailLanding'
import { routePaths } from '~/routes/routePaths'

type Props = {
  landing: SettlementDetailLanding
}

const DESTINATION_PATH: Record<SettlementDetailMarket, string> = {
  spot: routePaths.biddingSpot.path,
  intraday: routePaths.biddingIntraday.path,
}

/**
 * 清算書の行の「詳細」 (AC-JST-009)。 清算書に含まれる取引の約定結果を、 市場の入札画面で
 * 開く。 開く日は `landing` が持ち、 タブやフィルターの初期状態は開いた先が決める。
 */
export const SettlementDetailButton = ({
  landing,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <TertiaryButton
      // 表のセル内のボタンは全て DS の M サイズ (`size="md"` = 高さ 40px。 デザイナー判断 2026-10-30、
      // 旧 32px 規約の置き換え)。 高さ・padding・文字は recipe の既定のまま。
      onClick={() => {
        void navigate(DESTINATION_PATH[landing.market], {
          state: toSettlementDetailLandingState(landing),
        })
      }}
      size="md"
    >
      {t('page:jepxSettlement.action.detail')}
    </TertiaryButton>
  )
}
